var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flyerviewer',{ref:"viewer",attrs:{"page":_vm.page,"result":_vm.result,"previewMode":false}})}
var staticRenderFns = []

export { render, staticRenderFns }